(() => {
  try {
    const key = 'sensme-attribution-v1';
    const url = new URL(location.href);
    const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const clean = value => String(value || '').replace(/[\x00-\x1f]/g, '').slice(0, 160);
    const touch = Object.fromEntries(fields.map(name => [name, clean(url.searchParams.get(name))]));
    const referrer = document.referrer ? new URL(document.referrer) : null;
    touch.referrer = referrer && referrer.hostname !== url.hostname ? referrer.origin : '';
    touch.landing = url.pathname.slice(0, 160);
    touch.at = new Date().toISOString();
    const stored = JSON.parse(localStorage.getItem(key) || 'null');
    const hasCampaign = fields.some(name => touch[name]);
    const signature = value => JSON.stringify(fields.map(name => value?.[name]).concat(value?.referrer));
    if (!stored?.first || !stored?.last) localStorage.setItem(key, JSON.stringify({first: touch, last: touch}));
    else if ((hasCampaign || touch.referrer) && signature(stored.last) !== signature(touch)) {
      localStorage.setItem(key, JSON.stringify({first: stored.first, last: touch}));
    }
  } catch { /* Checkout still works when storage is unavailable. */ }
})();
